module.exports = __webpack_public_path__ + "media/images/athletes/4321-aef24a171244a0ee079f5766fda415f5.png";